import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionSummary,
  Grid,
  AccordionDetails,
  Typography,
  Divider,
  Breadcrumbs,
  Link,
} from "@mui/material";
import useForm, { Form } from "../../../../hooks/useForm";
import Controls from "../../../../components/form/controls/Controls";
import { checkEqual } from "../../../../utils";
import { Notify } from "../../../../components/notify/Notify";
import { CACHE_DEVICE } from "../../../../constants/actionCache";
import useCurrentActionCache from "../../../../hooks/useCurrentActionCache";
import { getFLFCategory } from "../../../../apis/FLF/category.api";
import {
  createFLFDevice,
  getFLFDeviceDetail,
  updateFLFDevice,
} from "../../../../apis/FLF/device.api";
import { getFLFIcon } from "../../../../apis/FLF/icon.api";
import { getFLFIotPartner } from "../../../../apis/FLF/iotPartner.api";
import { getFLFRogoDevSubType } from "../../../../apis/FLF/rogoDevSubType.api";
import { URL_CDN, path } from "../../../../constants/path";
import { getFLFPairingType } from "../../../../apis/FLF/pairingType.api";
import { refusedToUpdate } from "../../utils";
import { validationFLFDeviceInput } from "../../utils/validateInput";
import useQueryConfig from "../../../../hooks/useQueryConfig";

const PAGE = 1;
const LIMIT = 1000; // lấy 1000 category
const initialValue = {
  id: "",
  name: "",
  code: "",
  categoryId: "",
  devTypeCode: 0,
  devTypeStr: "",
  devSubTypeCode: 0,
  devSubTypeStr: "",
  // pairingType: "",
  isShowHomePage: false,
  avatar: "",
  iconId: "",
  iotPartnerId: "",
  icon: {
    id: "",
    pathname: "",
    deviceName: "",
  },
  rogoDevSubTypeIds: [],
  pairingTypeIds: [],
  productId: "",
  allowSkills: "",
};

const showHomePageOption = [
  {
    id: true,
    name: "Show",
  },
  {
    id: false,
    name: "Hide",
  },
];

const showAvatar = (file, avatar, deviceName) => {
  if (file) {
    return (
      <img
        style={{ width: "96px", height: "96px" }}
        src={file}
        alt={deviceName}
      />
    );
  }

  if (avatar) {
    return (
      <img
        style={{ width: "96px", height: "96px" }}
        src={`${URL_CDN}/${avatar}`}
        alt={deviceName}
      />
    );
  }

  return (
    <span style={{ color: "red", marginLeft: "25px" }}>
      chưa có avatar được chọn
    </span>
  );
};

const showIcon = (pathname, iconName) => {
  if (pathname) {
    return (
      <img
        style={{ width: "96px", height: "96px" }}
        src={`${URL_CDN}/${pathname}`}
        alt={iconName}
      />
    );
  }

  return (
    <span style={{ color: "red", marginLeft: "25px" }}>
      chưa có icon được chọn
    </span>
  );
};

const FLFDeviceAction = () => {
  // cache
  const { setCurrentActionCache } = useCurrentActionCache();

  let queryConfig = useQueryConfig();

  const { page = 10, limit = 10, categoryId, iotPartnerId } = queryConfig;

  let { id } = useParams();
  const history = useHistory();
  const fileInputRef = useRef(null);
  const [device, setDevice] = useState([]);
  const [categories, setCategories] = useState([]);
  const [icons, setIcons] = useState([]);
  const [iotPartners, setIotPartners] = useState([]);

  const [createAnother, setCreateAnother] = useState(false);
  const [iconDevice, setIconDevice] = useState(initialValue.icon);
  const [avatar, setAvatar] = useState([]);
  const [file, setFile] = useState();
  const [rogoDevSubtypes, setRogoDevSubTypes] = useState([]);
  const [pairingTypes, setPairingTypes] = useState([]);
  const [devSubTypeStringOptions, setDevSubTypeStringOptions] = useState([]);
  const [hashMapDevSubTypeStringToCode, setHashMapDevSubTypeStringToCode] =
    useState(null);
  // validation input flf-device
  const validateFLFDeviceForm = (fieldValues = values) => {
    let temp = validationFLFDeviceInput(fieldValues, { ...errors });

    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialValue, true, validateFLFDeviceForm);

  useEffect(() => {
    if (id) {
      getFLFDeviceDetail(id, (result) => {
        const rogoDevSubTypeIds = result.rogoDevSubTypes.map(
          (rogoDev) => rogoDev.id
        );

        const pairingTypeIds = result.pairingTypes.map(
          (pairingType) => pairingType.id
        );

        const value = {
          ...result,
          devTypeCode: result.devTypeCode ? result.devTypeCode : 0,
          devTypeStr: result.devTypeStr ? result.devTypeStr : "",
          devSubTypeCode: result.devSubTypeCode ? result.devSubTypeCode : 0,
          devSubTypeStr: result.devSubTypeStr ? result.devSubTypeStr : "",
          rogoDevSubTypeIds,
          pairingTypeIds,
        };

        setValues({ ...value });
        setDevice({ ...value });
        setIconDevice({ ...result.icon });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    // * Get list category
    getFLFCategory({ page: PAGE, limit: LIMIT }, (result) => {
      setCategories([...result.list]);
    });
    getFLFIotPartner({}, (result) => {
      setIotPartners([...result.list]);
    });

    getFLFIcon({}, (result) => {
      setIcons([...result.list]);
    });

    getFLFRogoDevSubType({}, (result) => {
      const devSubTypeStringOptions = [];
      const mapDevSubType = {};

      for (const rogo of result.list) {
        const { devSubTypeCode, devSubTypeStr } = rogo;
        mapDevSubType[devSubTypeStr] = devSubTypeCode;
        devSubTypeStringOptions.push({
          id: rogo.devSubTypeStr,
          name: `${rogo.devSubTypeStr} - ${rogo.devSubTypeCode}`,
          devSubTypeCode: rogo.devSubTypeCode,
          devSubTypeString: rogo.devSubTypeStr,
        });
      }

      setRogoDevSubTypes([...result.list]);
      setDevSubTypeStringOptions([...devSubTypeStringOptions]);
      setHashMapDevSubTypeStringToCode({ ...mapDevSubType });
    });

    getFLFPairingType({}, (result) => {
      setPairingTypes([...result.list]);
    });
  }, []);

  useEffect(() => {
    if (values.iconId) {
      const iconFound = icons.filter((icon) => icon.id === values.iconId);

      if (iconFound.length) {
        setIconDevice({ ...iconFound[0] });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.iconId]);

  const onSubmit = (e) => {
    e.preventDefault();

    if (validateFLFDeviceForm()) {
      const deviceData = {
        ...values,
        iconId: iconDevice.id,
      };

      const formData = new FormData();

      for (const [key, value] of Object.entries(deviceData)) {
        if (Array.isArray(value)) {
          value.forEach((val) => formData.append(key, val));
        } else {
          formData.append(key, value);
        }
      }

      if (id) {
        if (!checkEqual(device, values)) {
          if (file) {
            for (let i = 0; i < avatar.length; i++) {
              formData.append("image", avatar[0]);
            }
          }

          updateFLFDevice(id, formData, (result) => {
            // callback nhận về lỗi form và thành công
            if (result.data?.status === 422) {
              setErrors({ ...result.data.data });
            } else {
              setCurrentActionCache(CACHE_DEVICE);
              setIconDevice(initialValue.icon);
              history.push(
                `${path.flfDevice}?page=${page}&limit=${limit}&categoryId=${categoryId}&iotPartnerId=${iotPartnerId}`
              );
            }
          });
        }
      } else {
        if (!file) {
          Notify("warning", "Vui lòng chọn avatar");
          return;
        }
        // create icon
        if (!iconDevice?.pathname) {
          Notify("warning", "Vui lòng chọn icon");
          return;
        }

        for (let i = 0; i < avatar.length; i++) {
          formData.append("image", avatar[0]);
        }

        createFLFDevice(formData, (result) => {
          // callback nhận về lỗi form và thành công
          if (result.data?.status === 422) {
            setErrors({ ...result.data.data });
          } else {
            setCurrentActionCache(CACHE_DEVICE);
            setIconDevice(initialValue.icon);
            if (createAnother) {
              resetForm();
            } else {
              history.push(
                `${path.flfDevice}?page=${page}&limit=${limit}&categoryId=${categoryId}&iotPartnerId=${iotPartnerId}`
              );
            }
          }
        });
      }
    }
  };

  const handleFile = (e) => {
    fileInputRef.current?.setAttribute("value", "");
    setAvatar(e.target.files);
    setValues((prev) => {
      return {
        ...prev,
        avatar: "",
      };
    });
    setFile(URL.createObjectURL(e.target.files[0]));
  };

  const handleChangeFile = () => {
    fileInputRef.current?.click();
  };

  const handleSelectDevSubType = (event) => {
    const { value } = event.target;
    handleInputChange(event);

    setValues((prev) => {
      return {
        ...prev,
        devSubTypeCode: hashMapDevSubTypeStringToCode[value] || 0,
      };
    });
  };

  return (
    <>
      <div className="page-header">
        <h2>{id ? "Edit FLF Device" : "Add FLF Device"}</h2>
      </div>
      <Breadcrumbs aria-label="breadcrumb">
        <Link
          underline="hover"
          color="inherit"
          href={`${path.flfDevice}?page=${page}&limit=${limit}`}
        >
          FLF Device
        </Link>
        <Typography color="text.primary">
          {id ? "Edit FLF Device" : "Add FLF Device"}
        </Typography>
      </Breadcrumbs>

      <Form onSubmit={onSubmit} noValidate>
        <Grid container>
          <Grid item xs={6} p={5}>
            <Controls.Input
              name="name"
              value={values.name}
              label="Name"
              type="text"
              onChange={handleInputChange}
              error={errors.name}
            />
            <Controls.Input
              name="code"
              value={values.code}
              label="Code"
              type="text"
              onChange={handleInputChange}
              error={errors.code}
            />
            <Controls.Input
              name="devTypeCode"
              value={values.devTypeCode}
              label="Dev Type Code"
              type="number"
              onChange={handleInputChange}
              error={errors.devTypeCode}
            />
            <Controls.Input
              name="devTypeStr"
              value={values.devTypeStr}
              label="Dev Type String"
              type="text"
              onChange={handleInputChange}
              error={errors.devTypeStr}
            />

            <Controls.Select
              name="devSubTypeStr"
              label="RogoDevSubType"
              value={values.devSubTypeStr}
              onChange={handleSelectDevSubType}
              options={devSubTypeStringOptions}
              searchable={true}
              error={errors.devSubTypeStr}
            />

            {/* <Controls.Input
              name="devSubTypeCode"
              value={values.devSubTypeCode}
              label="Dev SubType Code"
              type="number"
              onChange={handleInputChange}
              error={errors.devSubTypeCode}
            />
            <Controls.Input
              name="devSubTypeStr"
              value={values.devSubTypeStr}
              label="Dev SubType Text"
              type="text"
              onChange={handleInputChange}
              error={errors.devSubTypeStr}
            />

            <Controls.Input
              name="productId"
              value={values.productId}
              label="Product"
              type="text"
              onChange={handleInputChange}
              error={errors.productId}
            /> */}

            <Controls.Input
              name="productId"
              value={values.productId}
              label="Product"
              type="text"
              onChange={handleInputChange}
              error={errors.productId}
            />

            {values.categoryId !== null ? (
              <Controls.Select
                name="categoryId"
                label="Category"
                value={values.categoryId}
                onChange={handleInputChange}
                options={categories}
                searchable={true}
                error={errors.categoryId}
              />
            ) : null}

            <Controls.Select
              name="iotPartnerId"
              label="Iot partner"
              value={values.iotPartnerId}
              onChange={handleInputChange}
              options={iotPartners.map((iotPartner) => ({
                ...iotPartner,
                name: iotPartner.partnerName,
              }))}
              searchable={true}
              error={errors.iotPartnerId}
            />

            <Controls.Button
              text="Select Avatar"
              sx={{ width: "100%", margin: "10px 0" }}
              onClick={handleChangeFile}
            />
          </Grid>
          <Grid item xs={6} p={5}>
            {values.iconId !== null ? (
              <Controls.Select
                name="iconId"
                label="Icon"
                value={values.iconId}
                onChange={handleInputChange}
                options={icons
                  .filter((icon) =>
                    ["device", "vms"].includes(icon.iconType)
                  )
                  .map((icon) => ({
                  ...icon,
                  name: icon.deviceName || "Unnamed device",
                  imageUrl: `${URL_CDN}/${icon.pathname || ""}`,
                }))}
                searchable={true}
                error={errors.iconId}
              />
            ) : null}
            <Controls.Input
              name="allowSkills"
              value={values.allowSkills}
              label="Allow Skills"
              type="text"
              onChange={handleInputChange}
              error={errors.allowSkills}
            />
            {/* <Controls.Select
              name="pairingType"
              label="Pairing Type"
              value={values.pairingType}
              onChange={handleInputChange}
              options={pairingOption}
              error={errors.pairingType}
            /> */}
            <Accordion
              sx={{
                borderRadius: "4px",
                margin: "10px 0",
                padding: "3px 0px",
                background: "unset",
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>RogoDevSubTypes</Typography>
              </AccordionSummary>
              <AccordionDetails
                sx={{
                  maxHeight: "300px",
                  overflowY: "auto",
                }}
              >
                <Divider />
                <Controls.MultipleCheckbox
                  name="rogoDevSubTypeIds"
                  label="RogoDevSubTypes"
                  value={values.rogoDevSubTypeIds}
                  onChange={handleInputChange}
                  options={rogoDevSubtypes}
                />
              </AccordionDetails>
            </Accordion>
            <Accordion
              sx={{
                borderRadius: "4px",
                margin: "15px 0",
                padding: "3px 0px",
                background: "unset",
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>PairingTypes</Typography>
              </AccordionSummary>
              <AccordionDetails
                sx={{
                  maxHeight: "300px",
                  overflowY: "auto",
                }}
              >
                <Divider />
                <Controls.MultipleCheckbox
                  name="pairingTypeIds"
                  label="PairingTypes"
                  value={values.pairingTypeIds}
                  onChange={handleInputChange}
                  options={pairingTypes}
                />
              </AccordionDetails>
            </Accordion>
            <Controls.Select
              name="isShowHomePage"
              label="Show on homepage"
              value={values.isShowHomePage}
              onChange={handleInputChange}
              options={showHomePageOption}
              error={errors.isShowHomePage}
            />
            <div style={{ marginTop: "5px" }}>
              <h4 style={{ marginBottom: "10px" }}>Avatar Device</h4>
              {showAvatar(file, values.avatar, values.name)}
            </div>
            <div style={{ margin: "40px 0px 15px 0px" }}>
              <h4 style={{ marginBottom: "10px" }}>Icon Device</h4>
              {showIcon(iconDevice?.pathname, values.name)}
            </div>
            {/* hidden input */}
            <input
              style={{ display: "none" }}
              type="file"
              accept="image/png, img/jpg"
              name={values.name}
              className="form-control"
              onChange={handleFile}
              required
              ref={fileInputRef}
              onClick={(event) => {
                event.target.value = null;
              }}
            ></input>

            {!id ? (
              <Controls.Checkbox
                name="createAnother"
                label="Create another"
                value={createAnother}
                onChange={() => setCreateAnother(!createAnother)}
              />
            ) : null}

            <div style={{ marginTop: "10px" }}>
              <Controls.Button
                type="submit"
                text="Submit"
                disabled={refusedToUpdate(id, checkEqual(device, values))}
              />

              <Controls.Button
                text="Reset"
                color="inherit"
                onClick={() => {
                  setIconDevice({ id: "", pathname: "" });
                  resetForm();
                }}
              />
            </div>
          </Grid>
        </Grid>
      </Form>
    </>
  );
};

export default FLFDeviceAction;
